module.exports = __webpack_public_path__ + "static/img/stems.a411b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stems.png
// module id = zAEq
// module chunks = 1